<script>
	import model from 'model/model';
	import pubsub from 'events/pubsub';

	export default {
		props: ['article', 'routeContext', 'paragraphsNumbered'],
		components: {
			'content-body': require('components/content-body.vue').default
		},
		modelData: ['userContext', 'whiteboardView', 'decodablesSection', 'decodablesArticle'],
		computed: {
			selectedGroup() {
				return this.article.dteGroups.find(group => group.id === model.get('decodablesSection'));
			},
			selectedArticle() {
				return this.selectedGroup.articles[this.decodablesArticle];
			},
			articleList() {
				return Object.values(this.selectedGroup.articles);
			}
		},
		methods: {
			onArticleSelect(pid) {
				this.decodablesArticle = pid;
			}
		},
		watch: {
			article: {
				handler(article) {
					if (article) {
						// Check against model directly
						// this runs before model mapped to component
						if (!model.get('decodablesSection')) {
							model.set('decodablesSection', article.dteGroups[0].id);
						}

						if (!model.get('decodablesArticle')) {
							model.set('decodablesArticle', this.articleList[0].uuid);
						}
					}
				},
				immediate: true
			},
			selectedArticle(article) {
				pubsub.publish('article-selected', article);
			}
		}
	};
</script>
<style lang="scss">
	.decodables {
		article {
			font-size: 1.75em;
		}
	}
</style>
<template>
	<content-body
		v-if="article"
		:class="[
			'decodables',
			{
				wrapper: routeContext.params.assignmentId
			}
		]"
		:article="article"
		:article-list="articleList"
		:selected-article="selectedArticle"
		:route-context="routeContext"
		:on-article-select="onArticleSelect"
		:force-highlighting="whiteboardView"
		:decodables="true"
		:show-audio="false"
		:show-support="false"
		:show-challenge="false"
		:paragraphs-numbered="paragraphsNumbered"></content-body>
</template>
